'use client'
import { Radio as ChakraRadio } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { RadioProps } from './Radio.types'

export default forwardRef(function Radio(
  props: RadioProps,
  ref: LegacyRef<HTMLInputElement>
) {
  return <ChakraRadio {...props} ref={ref} translate="no" />
})
